import React, {useEffect, useState} from 'react';
import {Col, Row} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Swal from "sweetalert2";
import '@sweetalert2/theme-dark/dark.scss';
import DatePicker from "react-date-picker";
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import "../../layout/styles/components/date-picker.scss";
import {getSystemInfo, putSystemInfo, regSystemInfo} from "../../api/apiClient";
import Moment from "moment";

const SystemReg = ({
                     propSysno,
                     hClose
                   }) => {

  const [systemInfo, setSystemInfo] = useState({
    instl_de: Moment(new Date()).format('YYYY-MM-DD'),
  });

  const updateSystemInfo = () => {
    if (propSysno) {
      getSystemInfo(propSysno)
          .then(response => {
            console.log(response);
            if (response.data.data !== undefined) {
              setSystemInfo(response.data.data);
            }
          });
    }
  };

  useEffect(() => {
    updateSystemInfo();
  }, []);


  const onChangeInfo = (name, value) => {
    let newInfo = {...systemInfo};
    newInfo[name] = value;
    setSystemInfo(newInfo);
  };

  const onSubmit = () => {
    if (!systemInfo.host_nm) {
      Swal.fire(
          '호스트명은 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }
    if (!systemInfo.sys_nm) {
      Swal.fire(
          '시스템명은 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }
    if (!systemInfo.ip_addr) {
      Swal.fire(
          'IP는 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }
    if (!systemInfo.instl_de) {
      Swal.fire(
          '설치일자는 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }

    if (!propSysno) {
      // 등록
      regSystemInfo(systemInfo)
          .then((res) => {
            if (res.status === 200) {
              let data = res.data;
              Swal.fire(
                  '정상적으로 처리 되었습니다!',
                  '',
                  'success'
              );
              hClose();
            }
          })
          .catch(err => {
            Swal.fire(
                err.response.data.message,
                '',
                'error'
            );
          });
    } else {
      // 수정
      let newInfo = {...systemInfo};
      newInfo.sysno = propSysno;
      setSystemInfo(newInfo);
      putSystemInfo(systemInfo)
          .then((res) => {
            if (res.status === 200) {
              let data = res.data;
              Swal.fire(
                  '정상적으로 처리 되었습니다!',
                  '',
                  'success'
              );
              hClose();
            }
          })
          .catch(err => {
            Swal.fire(
                err.response.data.message,
                '',
                'error'
            );
          });
    }

  };

  return (
      <Row className={"layer"}>
        <Col className={''}>
          <Row className={'info-container py-2 mx-3'}>
            <Col md={11} className={'px-5'}>
              <div className={'content-container-body-item'}>
                <Form
                    className={'gateway-register-form py-3'}
                    id={'firmwareRegisterForm'}
                >
                  <Row className={"justify-content-center"}>
                    <Col md={12}>
                      <Row>
                        <Col md={12}>
                          <Form.Group as={Row} controlId='formIp2Addr'>
                            <Form.Label column md={4} className={'label text-end fw-bold'}>
                              <span className={"text-danger"}>* </span>호스트명
                            </Form.Label>
                            <Col md={8}>
                              <Form.Control
                                  type='text'
                                  className={'input text-white'}
                                  onChange={(e) => {
                                    onChangeInfo('host_nm', e.target.value);
                                  }}
                                  // defaultValue={(systemInfo !== null) ? systemInfo.host_nm : '' || ''}
                                  value={(systemInfo !== null) ? systemInfo.host_nm : '' || ''}
                                  required
                              />
                            </Col>
                          </Form.Group>
                        </Col>

                        <Col md={12}>
                          <Form.Group as={Row} controlId='formIp1Addr'>
                            <Form.Label column md={4} className={'label text-end fw-bold'}>
                              <span className={"text-danger"}>* </span>시스템명
                            </Form.Label>
                            <Col md={8} className={''}>
                              <Form.Control
                                  type='text'
                                  className={'input text-white'}
                                  onChange={(e) => {
                                    onChangeInfo('sys_nm', e.target.value);
                                  }}
                                  // defaultValue={(systemInfo !== null) ? systemInfo.sys_nm : '' || ''}
                                  value={(systemInfo !== null) ? systemInfo.sys_nm : '' || ''}
                                  required
                              />
                            </Col>
                          </Form.Group>
                        </Col>

                        <Col md={12}>
                          <Form.Group as={Row} controlId='formIp2Addr'>
                            <Form.Label column md={4} className={'label text-end'}>
                              모델
                            </Form.Label>
                            <Col md={8}>
                              <Form.Control
                                  type='text'
                                  className={'input text-white'}
                                  onChange={(e) => {
                                    onChangeInfo('modl', e.target.value);
                                  }}
                                  // defaultValue={(systemInfo !== null) ? systemInfo.modl : '' || ''}
                                  value={(systemInfo !== null) ? systemInfo.modl : '' || ''}
                                  required
                              />
                            </Col>
                          </Form.Group>
                        </Col>

                        <Col md={12}>
                          <Form.Group as={Row} controlId='forml2IpAddr'>
                            <Form.Label column md={4} className={'label text-end fw-bold'}>
                              <span className={"text-danger"}>* </span>IP
                            </Form.Label>
                            <Col md={8}>
                              <Form.Control
                                  type='text'
                                  className={'input text-white'}
                                  onChange={(e) => {
                                    onChangeInfo('ip_addr', e.target.value);
                                  }}
                                  // defaultValue={(systemInfo !== null) ? systemInfo.ip_addr : '' || ''}
                                  value={(systemInfo !== null) ? systemInfo.ip_addr : '' || ''}
                                  required
                              />
                            </Col>
                          </Form.Group>
                        </Col>

                        <Col md={12}>
                          <Form.Group as={Row} controlId='formInstlDe'>
                            <Form.Label column md={4} className={'label text-end fw-bold'}>
                              <span className={"text-danger"}>* </span>설치일자
                            </Form.Label>
                            <Col md={8} className={''}>
                              <DatePicker
                                  onChange={(date) => {
                                    onChangeInfo('instl_de', Moment(date).format('YYYY-MM-DD'));
                                  }}
                                  value={systemInfo.instl_de ? new Date(systemInfo.instl_de) : new Date()}
                                  format={"yyyy-MM-dd"}
                                  clearIcon={null}
                                  className={"datepicker-start w-100 text-center"}
                              />
                            </Col>
                          </Form.Group>
                        </Col>

                      </Row>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
          <Row className={"my-3 justify-content-center"}>
            <Col md={2} className={'justify-content-center'}>
              <Button
                  className={'btn save-btn w-100'}
                  onClick={onSubmit}
              >저장</Button>
            </Col>
            <Col md={2} className={'justify-content-center text-end'}>
              <Button className={'btn btn-secondary w-100'} onClick={hClose}>취소</Button>
            </Col>
          </Row>
        </Col>
      </Row>
  );
};

export default SystemReg;
